import { Currency, Money } from '../type/order';
/**
 * Returns a random integer between min (inclusive) and max (inclusive).
 * @param min the minimum(inclusive) integer the number can be.
 * @param max the maximum(inclusive) integer the number can be.
 */
export function randomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
/**
 * Creates a Money type with a random amount. This helps ensure that testing is not bound to a certain money
 * amount.
 *
 * E.g.: If you want to test a function that accepts two distinct money values and that each money value is handled
 * appropriately, you don't want to pass in two test moneys with the same value as you may miss important bugs.
 *
 * Note: this function is often used in testing our Stripe integration. Our Stripe test account has a minimum
 * transaction fee of 50 AUD cents, so please make sure that the `minAmount` you specify will exceed this amount by a
 * margin large enough to account for a changing conversion rate.
 */
export function randomMoney(props = {}, currency = Currency.CAD, minAmount = 1, maxAmount = 10) {
    const centsInDollar = 100;
    const amount = randomInt(minAmount * centsInDollar, maxAmount * centsInDollar) / centsInDollar;
    return Object.assign(new Money(amount, currency), props);
}
